"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNSignersNeeded = exports.getAllRequiredSigners = exports.Tx = void 0;
var credentials_1 = require("../credentials/index.js");
var hashes_1 = require("../hashes/index.js");
var TxWitnessSet_1 = require("./TxWitnessSet/index.js");
var cbor_1 = require("@harmoniclabs/cbor");
var crypto_1 = require("@harmoniclabs/crypto");
var obj_utils_1 = require("@harmoniclabs/obj-utils");
var InvalidCborFormatError_1 = require("../utils/InvalidCborFormatError.js");
var assert_1 = require("../utils/assert.js");
var AuxiliaryData_1 = require("./AuxiliaryData/index.js");
var body_1 = require("./body/index.js");
var bip32_ed25519_1 = require("@harmoniclabs/bip32_ed25519");
var Tx = /** @class */ (function () {
    function Tx(tx) {
        var _this = this;
        var body = tx.body, witnesses = tx.witnesses, isScriptValid = tx.isScriptValid, auxiliaryData = tx.auxiliaryData;
        (0, assert_1.assert)(body instanceof body_1.TxBody || (0, body_1.isITxBody)(body), "invalid transaction body; must be instance of 'TxBody'");
        (0, assert_1.assert)((0, TxWitnessSet_1.isITxWitnessSet)(witnesses), "invalid wintesses; must be instance of 'TxWitnessSet'");
        (0, assert_1.assert)(isScriptValid === undefined || typeof isScriptValid === "boolean", "'isScriptValid' ('Tx' third paramter) must be a boolean");
        (0, assert_1.assert)(auxiliaryData === undefined ||
            auxiliaryData === null ||
            auxiliaryData instanceof AuxiliaryData_1.AuxiliaryData, "invalid transaction auxiliray data; must be instance of 'AuxiliaryData'");
        (0, obj_utils_1.defineReadOnlyProperty)(this, "body", new body_1.TxBody(body));
        (0, obj_utils_1.defineReadOnlyProperty)(this, "witnesses", new TxWitnessSet_1.TxWitnessSet(witnesses, getAllRequiredSigners(this.body)));
        (0, obj_utils_1.defineReadOnlyProperty)(this, "isScriptValid", isScriptValid === undefined ? true : isScriptValid);
        (0, obj_utils_1.defineReadOnlyProperty)(this, "auxiliaryData", auxiliaryData);
        (0, obj_utils_1.definePropertyIfNotPresent)(this, "hash", {
            // needs to be a getter because `this.body.hash` is a getter
            get: function () { return _this.body.hash; },
            set: function () { },
            enumerable: true,
            configurable: false
        });
        //*
        (0, obj_utils_1.defineReadOnlyProperty)(this, "addVKeyWitness", function (vkeyWit) { return _this.witnesses.addVKeyWitness(vkeyWit); });
        (0, obj_utils_1.defineReadOnlyProperty)(this, "signWith", function (signer) {
            if (signer instanceof Uint8Array && signer.length >= 64) {
                signer = bip32_ed25519_1.XPrv.fromExtended(signer.slice(0, 64), new Uint8Array(32));
            }
            if (signer instanceof bip32_ed25519_1.XPrv) {
                var _a = signer.sign(_this.body.hash.toBuffer()), pubKey_1 = _a.pubKey, signature_1 = _a.signature;
                _this.addVKeyWitness(new TxWitnessSet_1.VKeyWitness(new TxWitnessSet_1.VKey(pubKey_1), new hashes_1.Signature(signature_1)));
                return;
            }
            var _b = (0, crypto_1.signEd25519)(_this.body.hash.toBuffer(), signer instanceof Uint8Array ? signer : signer.toBuffer()), pubKey = _b.pubKey, signature = _b.signature;
            _this.addVKeyWitness(new TxWitnessSet_1.VKeyWitness(new TxWitnessSet_1.VKey(pubKey), new hashes_1.Signature(signature)));
        });
        (0, obj_utils_1.defineReadOnlyProperty)(this, "signWithCip30Wallet", function (cip30) { return __awaiter(_this, void 0, void 0, function () {
            var wits, _a, _b, _c, _d, wit;
            var e_1, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _b = (_a = TxWitnessSet_1.TxWitnessSet).fromCbor;
                        return [4 /*yield*/, cip30.signTx(
                            // signTx expects the entire transaction by standard (not only the body ¯\_(ツ)_/¯)
                            this.toCbor().toString(), true)];
                    case 1:
                        wits = _b.apply(_a, [_f.sent()]);
                        try {
                            for (_c = __values(wits.vkeyWitnesses), _d = _c.next(); !_d.done; _d = _c.next()) {
                                wit = _d.value;
                                this.addVKeyWitness(wit);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_d && !_d.done && (_e = _c.return)) _e.call(_c);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [2 /*return*/];
                }
            });
        }); });
        Object.defineProperty(this, "isComplete", {
            // calls the `TxWitnessSet` getter
            get: function () { return _this.witnesses.isComplete; },
            set: function () { },
            configurable: false,
            enumerable: true
        });
        //*/
    }
    Tx.prototype.toCbor = function () {
        return cbor_1.Cbor.encode(this.toCborObj());
    };
    Tx.prototype.toCborObj = function () {
        return new cbor_1.CborArray([
            this.body.toCborObj(),
            this.witnesses.toCborObj(),
            new cbor_1.CborSimple(this.isScriptValid),
            this.auxiliaryData === undefined || this.auxiliaryData === null ?
                new cbor_1.CborSimple(null) :
                this.auxiliaryData.toCborObj()
        ]);
    };
    Tx.fromCbor = function (cStr) {
        return Tx.fromCborObj(cbor_1.Cbor.parse((0, cbor_1.forceCborString)(cStr)));
    };
    Tx.fromCborObj = function (cObj) {
        if (!(cObj instanceof cbor_1.CborArray))
            throw new InvalidCborFormatError_1.InvalidCborFormatError("Tx");
        var _a = __read(cObj.array, 4), _body = _a[0], _wits = _a[1], _isValid = _a[2], _aux = _a[3];
        if (!(_isValid instanceof cbor_1.CborSimple &&
            typeof (_isValid.simple) === "boolean"))
            throw new InvalidCborFormatError_1.InvalidCborFormatError("Tx", "isScriptValid is not a boolean");
        var noAuxiliaryData = _aux instanceof cbor_1.CborSimple && (_aux.simple === null || _aux.simple === undefined);
        return new Tx({
            body: body_1.TxBody.fromCborObj(_body),
            witnesses: TxWitnessSet_1.TxWitnessSet.fromCborObj(_wits),
            isScriptValid: _isValid.simple,
            auxiliaryData: noAuxiliaryData ? undefined : AuxiliaryData_1.AuxiliaryData.fromCborObj(_aux)
        });
    };
    Tx.prototype.toJson = function () {
        var _a;
        return {
            body: this.body.toJson(),
            witnesses: this.witnesses.toJson(),
            isScriptValid: this.isScriptValid,
            auxiliaryData: (_a = this.auxiliaryData) === null || _a === void 0 ? void 0 : _a.toJson()
        };
    };
    return Tx;
}());
exports.Tx = Tx;
/**
 * signers needed are:
 *  - required to spend an utxo
 *  - required by certificate
 *  - required by withdrawals
 *  - additional specified in the `requiredSigners` field
 */
function getAllRequiredSigners(body) {
    var _a;
    var _b, _c, _d, _e, _f, _g;
    return (
    // required for spending pubKey utxo
    (_a = body.inputs.reduce(function (acc, _in) {
        var _a = _in.resolved.address.paymentCreds, type = _a.type, hash = _a.hash;
        if (type === credentials_1.CredentialType.KeyHash)
            acc.push(new credentials_1.PubKeyHash(hash));
        return acc;
    }, [])
        // required to sign certificate
        .concat((_c = (_b = body.certs) === null || _b === void 0 ? void 0 : _b.reduce(function (acc, cert) { return acc.concat(cert.getRequiredSigners()); }, [])) !== null && _c !== void 0 ? _c : [])
        // requred for withdrawal
        .concat((_e = (_d = body.withdrawals) === null || _d === void 0 ? void 0 : _d.map.map(function (_a) {
        var rewardAccount = _a.rewardAccount;
        return rewardAccount.credentials.clone();
    })) !== null && _e !== void 0 ? _e : []))
        .concat.apply(_a, __spreadArray([], __read((_g = (_f = body.requiredSigners) === null || _f === void 0 ? void 0 : _f.map(function (sig) { return sig.clone(); })) !== null && _g !== void 0 ? _g : []), false))).filter(function (elem, i, thisArr) { return thisArr.indexOf(elem) === i; });
}
exports.getAllRequiredSigners = getAllRequiredSigners;
function getNSignersNeeded(body) {
    var n = getAllRequiredSigners(body).length;
    return n === 0 ? 1 : n;
}
exports.getNSignersNeeded = getNSignersNeeded;
